import React from 'react';
import { warnIconOrange } from '../../assets/hostedassets';
import LoadingSpinner from '../_custom/LoadingSpinner/LoadingSpinner';
import { BANNER_MODE, BannerMode } from '../../store/banking/constants';
import styles from './PendingBankStatementsBanner.module.scss';

interface PendingBankStatementsBannerProps {
    mode: BannerMode;
    canExtract: boolean;
    pendingCount: number;
    inFlightCount: number;
    processedCount: number;
    totalCount: number;
    onExtractClick: () => void;
    onDismiss: () => void;
}

const PendingBankStatementsBanner = ({
    mode,
    canExtract,
    pendingCount,
    inFlightCount,
    processedCount,
    totalCount,
    onExtractClick,
    onDismiss,
}: PendingBankStatementsBannerProps) => {
    if (mode === BANNER_MODE.IN_PROGRESS) {
        return (
            <div className={styles.Banner} role="status" aria-live="polite">
                <div className={styles.Left}>
                    <LoadingSpinner color="#8E732E" height="16px" />
                    <span className={styles.Message}>{`${processedCount}/${totalCount} files extraction in progress`}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.Banner} role="alert">
            <div className={styles.Left}>
                <img className={styles.WarnIcon} src={warnIconOrange} alt="Warning" />
                <span className={styles.Message}>
                    {`You have received ${pendingCount} new bank account statement${
                        pendingCount !== 1 ? 's' : ''
                    } where data has not been extracted. `}
                    {inFlightCount > 0 && (
                        <span className={styles.InFlightHint}>
                            {`(${inFlightCount} extraction${inFlightCount !== 1 ? 's' : ''} in progress) `}
                        </span>
                    )}
                    {canExtract && (
                        <button className={styles.ExtractLink} onClick={onExtractClick}>
                            Extract Now
                        </button>
                    )}
                </span>
            </div>
            <button className={styles.DismissButton} onClick={onDismiss} aria-label="Dismiss banner">
                &times;
            </button>
        </div>
    );
};

export default PendingBankStatementsBanner;
